import { head } from 'lodash'

export const loaddingHelper = {
  data () {
    return {
      changedData: false,
      watching: false
    }
  },
  methods: {
    message200 () {
      this.$notify({
        type: 'success',
        title: 'Success',
        message: 'Completed!'
      })
    },
    messageDelete200 () {
      this.$notify({
        type: 'success',
        title: 'Success',
        message: 'Delete Completed!'
      })
    },
    message403 (params) {
      var title = params !== undefined ? params : 'You do not have permission to access!'
      this.$notify.error({
        title: title,
        message: ''
      })
    },
    message404 () {
      this.$notify({
        type: 'warning',
        title: 'Error',
        message: '404 Not found.'
      })
    },
    message422 (errors) {
      let message = head(errors[Object.keys(errors)[0]])
      this.$notify({
        title: 'Error',
        message: message,
        type: 'warning'
      })
    },
    messageError (params) {
      var title = params !== undefined ? params : 'Error'
      this.$notify.error({
        title: title,
        message: 'Oops! Something went wrong !'
      })
    },
    messageValidate () {
      this.$notify.error({
        title: 'Error',
        message: 'Check your submit!'
      })
    },
    messageCancel () {
      this.$message({
        type: 'info',
        message: 'Canceled!'
      })
    },
    trimText (text, number) {
      if (text) {
        if (text.length < number) {
          return text
        } else {
          return text.substr(0, number) + '...'
        }
      } else {
        return ''
      }
    },
    encodeUrl (url) {
      return encodeURI(url).replace("'", '%27')
    },
    formatLink (link) {
      if (link.includes('http')) {
        return link
      } else {
        return '//' + link
      }
    }
  },
  metaInfo: {
    title: '360tovisit Webapp',
    titleTemplate: '%s | 360tovisit'
  },
  watch: {
    changedData (value) {
      if (value) {
        window.onbeforeunload = (e) => {
          return false
        }
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.changedData) {
      this.$confirm('Leave site? Changes you made may not be saved', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        next()
      }).catch(() => {
        this.watching = true
      })
    } else {
      next()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/index.js